// extracted by mini-css-extract-plugin
export default {"container":"newsInternal_container__QzZ9f","content":"newsInternal_content__GFRH5","post":"newsInternal_post__KtmZu","all":"newsInternal_all__bFCbT"};